<!--The content below is only a placeholder and can be replaced.-->
<clr-main-container>
        <app-header></app-header>

        <router-outlet></router-outlet>

</clr-main-container>


